module.exports = __webpack_public_path__ + "static/media/sharepoint.85bebe54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/sharepoint.jpg
// module id = 878
// module chunks = 15